module.exports = __webpack_public_path__ + "static/media/location-icon.f3105d46.svg";